import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createEnquiry = async (payload) => {
  const res = await axios.post(`${API}/enquiries`, payload, { timeout: 15000 });
  return res.data;
};

export const pingHealth = async () => {
  try {
    const res = await axios.get(`${API}/health`);
    return res.data;
  } catch (e) {
    return null;
  }
};
